import { createSelector } from 'reselect';

export const authByGoogleStateSelector = state => state.auth.authByGoogle;

export const authByGoogleSigningSelector = createSelector(
  authByGoogleStateSelector,
  s => s.isSigning
);

export const authByGoogleErrorSelector = createSelector(
  authByGoogleStateSelector,
  s => s.signError
);


// WEBPACK FOOTER //
// ./src/app/modules/auth/store/auth-by-google/selectors.ts